import { Button } from '@velocity/ui'
import { useMemo } from 'react'

import { useContent, useLocalization } from '@ngb-frontend/shared/context'
import { resolveBrandRules } from '@ngb-frontend/shared/rules'
import { formatPhoneNumber } from '@ngb-frontend/shared/utils'

interface PhoneButtonProps {
  withCallLabel?: boolean
}

export const PhoneButton: React.FC<PhoneButtonProps> = ({ withCallLabel }) => {
  const c = useContent()
  const { country } = useLocalization()

  const phone = useMemo(() => {
    const phoneNumber =
      resolveBrandRules(country).phoneNumber ?? c('steps.shared.phoneNumber')
    return formatPhoneNumber(phoneNumber)
  }, [c, country])

  return (
    <Button
      size="s"
      component="a"
      href={`tel:${phone}`}
      variant="primary-filled"
    >
      {withCallLabel
        ? c('steps.shared.callPhone', { variables: { phone } })
        : phone}
    </Button>
  )
}
